import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import { Message } from "@arco-design/web-vue";
import { getToken } from "@/utils/auth";

export interface HttpResponse<T = unknown> {
  status: number;
  msg: string;
  code: number;
  data: T;
}

// if (import.meta.env.VITE_API_BASE_URL) {
//   axios.defaults.baseURL = import.meta.env.VITE_API_BASE_URL;
// }
axios.defaults.headers.post["Content-Type"] = "application/json;charset=UTF-8";
axios.defaults.timeout = 60000;
axios.interceptors.request.use(
  (config: AxiosRequestConfig) => {
    // let each request carry token
    // this example using the JWT token
    // Authorization is a custom headers key
    // please modify it according to the actual situation
    const token = getToken();
    if (token) {
      if (!config.headers) {
        config.headers = {};
      }
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // do something
    return Promise.reject(error);
  }
);
// add response interceptors
axios.interceptors.response.use(
  (response: AxiosResponse<HttpResponse>) => {
    const res = response.data;

    // if the custom code is not 20000, it is judged as an error.
    // if (res.code !== 200) {
    //   // Message.error({
    //   //   content: res.msg || "Error",
    //   //   duration: 5 * 1000,
    //   // });

    //   return Promise.reject(res.msg || "Error");
    // }
    return res;
  },
  (error) => {
    Message.error({
      content: error.msg || "连接错误，请稍后重试",
      duration: 5 * 1000,
    });
    return Promise.reject(error);
  }
);
